var map = {
	"./en_us.png": "51af",
	"./es_spa.png": "6542",
	"./ja_ja.png": "2f09",
	"./ko_ko.png": "36eb",
	"./ms_my.png": "30e0",
	"./vn_vn.png": "ce48",
	"./zh_cn.png": "d0dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe4b";